import { sendHeartbeat } from "./analytics/sendHeartbeat";
import { sendPageView } from "./analytics/sendPageView";
import yieldToMain from "./lodash/yieldToMain";

export function activityWatcher() {
  // let timer;
  // The function that will be called whenever a user is active, or site loads.
  // function activity() {
  //   if (timer) {
  //     clearTimeout(timer);
  //   }

  //   if (!useActivityStartTime) {
  //     // reset the start time, when user becomes active again.
  //     useActivityStartTime = new Date().getTime();
  //   }

  //   // function will be called once user is inactive for 30 seconds of being active.
  //   timer = setTimeout(() => {
  //     setUserInactive();
  //   }, 1000 * 30);
  // }

  // //An array of DOM events that should be interpreted as
  // //user activity.
  // var activityEvents = [
  //   "mousedown",
  //   "mousemove",
  //   "keydown",
  //   "scroll",
  //   "touchstart"
  // ];

  // //add these events to the document.
  // //register the activity function as the listener parameter.
  // activityEvents.forEach(eventName => {
  //   document.addEventListener(eventName, activity, true);
  // });

  document.addEventListener("visibilitychange", () => {
    if (document.hidden) {
      setUserInactive();
    } else {
      setUserActive();
    }
  }, { passive: true });
}

let userInactiveTimeDuration = 0;
let userInactiveStartTime: any;
function setUserInactive() {
  // console.log("use is inactive again");
  userInactiveStartTime = new Date().getTime();
  // pauses heartbeat.
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  if (heartBeatTimer) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    clearInterval(heartBeatTimer);
  }
}

function setUserActive() {
  // console.log("use is active");
  userInactiveTimeDuration += new Date().getTime() - userInactiveStartTime;
  // restart heartbeart again
  startHeartBeatEvent();
}

// first start time is when application mounts.
let useActivityStartTime: any;
let eventApiCallCount = 0;
let eventApiCallDelay = 10; // in sec
let heartBeatTimer: any;
// send heart beat (1,2, 3 - every 10 seconds; 4, 5, 6 - every 20 seconds; others - 30 seconds)
function startHeartBeatEvent() {
  if (!useActivityStartTime) {
    useActivityStartTime = new Date().getTime();
  }

  heartBeatTimer = setInterval(() => {
    // eslint-disable-next-line no-plusplus
    eventApiCallCount++;
    const timeSpent = (new Date().getTime() - useActivityStartTime - userInactiveTimeDuration)
      / 1000;
    const url = window.location.href;
    sendHeartbeat({ timeSpent, url });
    // reset time, once it sent
    useActivityStartTime = new Date().getTime();
    if (eventApiCallCount % 3 === 0 && eventApiCallCount < 7) {
      clearInterval(heartBeatTimer);
      eventApiCallDelay += 10;
      startHeartBeatEvent();
    }
  }, 1000 * eventApiCallDelay);
}

// reset heart beat event loop,
function resetHeartBeatLocally() {
  if (heartBeatTimer) {
    clearInterval(heartBeatTimer);
    eventApiCallCount = 0;
    eventApiCallDelay = 10;
    userInactiveTimeDuration = 0;
  }
  useActivityStartTime = new Date().getTime();
  startHeartBeatEvent();
}

export const logPageView = async (url: any, referrer: any, isFirstPage: any) => {
  await yieldToMain();
  if (isFirstPage) {
    sendPageView({ url, referrer });
    resetHeartBeatLocally();
    return;
  }
  const timeSpent = (new Date().getTime() - useActivityStartTime - userInactiveTimeDuration)
    / 1000;
  // time spend on last page,
  // ignore event if user have spend time less then 1 sec.
  if (!(timeSpent > 0 && timeSpent < 1)) {
    sendHeartbeat({ timeSpent, url: referrer });
    // send page url
    sendPageView({ url, referrer });
    resetHeartBeatLocally();
  }
};
